import React from 'react';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale-provider/pt_BR';
import 'antd/dist/antd.less';
import Routes from './routes/Routes';
import store from './redux/store';
import './i18n/i18n';

const App = (): React.ReactElement => (
  <Provider store={store}>
    <ConfigProvider locale={ptBR}>
      <Routes />
    </ConfigProvider>
  </Provider>
);

export default App;
